import React from "react";
import "./Overview.scss";
import FHIR from "../../../assets/Images/FHIRimage.svg";
import { TextContent } from "../../../shared/TextContent/TextContent";
import { NAVIGATE_TO } from "../../../constants/FileConstants";
import { Link } from "react-router-dom";
import config from "../../../config";
// import StripedTable from '../../shared/StripedTable/StripedTable';
// import { SupportedSytemOperations } from "../../constants/TableData";

const PDEX_URL = config.pdex_implementation_guide;
const SMART_URL = config.smart_implementation_guide;
const US_CORE_URL = config.us_core;
const CARIN_IG_FOR_BLUE_BUTTON = config.carin_ig_for_blue_button;

const Overview = () => {
  return (
    <section id="overview-section">
      <div className="top-title-container">
        <img src={FHIR} alt="FHIR Logo" className="top-title-image" />
        <h1 className="top-title">
          <span className="red-text">FHIR</span> API Documentation
        </h1>
      </div>
      <div className="section-container">
        <TextContent header="Overview" description={""} />
        <div className="paragraph-container">
          <p className="paragraph">
            This API documentation provides the information on all the technical
            capabilities we support for different API’s.
          </p>
          <p className="paragraph">
            Our FHIR API endpoint implements the{" "}
            <a rel="noreferrer" href="https://hl7.org/fhir/R4/" target="_blank">
              R4
            </a>{" "}
            FHIR version and {" "}
            <a rel="noreferrer" href={`${US_CORE_URL}`} target="_blank">
              US Core
            </a> &{" "}
            <a rel="noreferrer" href={`${CARIN_IG_FOR_BLUE_BUTTON}`} target="_blank">
              CARIN IG for Blue Button®
            </a>{" "}
            implementation guide.
          </p>
          <p className="paragraph">
            Elevance Health support the{" "}
            <a target="_blank" rel="noreferrer" href={`${SMART_URL}`}>
              SMART Implementation Guide
            </a>{" "}
            to provide members clinical and claims access to the third-party
            applications through our patient access API.
          </p>
          <p className="paragraph">
            Providers and Payers can also use the member match operation as
            defined in the{" "}
            <a rel="noreferrer" href={`${PDEX_URL}`} target="_blank">
              Pdex Implementation guide
            </a>{" "}
            to get access member claims and clinical, non-sensitive data.
          </p>
        </div>
        <div className="button-container">
          <a
            href={NAVIGATE_TO.ENTITY_REGISTRATION_APPLICATION}
            target="_blank"
            className="custom-button"
            id="demo-btn"
          >
            Demo Here
          </a>
        </div>
        <div className="paragraph-container">
          <p className="paragraph">
            The documentation is separated into the following sections:
          </p>
          <ul className="paragraph-list">
            <li>
              <strong>Get Started</strong> with directions on how to implement
              our FHIR API across different access levels
            </li>
            <li>
              <strong>Supported capabilities</strong> which include supported
              resources and system operations
            </li>
            {/* <li><strong>Standard systems</strong> which include identifier and coding systems</li>
                        <li><strong>Mappings</strong> for concept and import mappings</li>
                        <li><strong>Code Terms</strong></li> */}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Overview;
